export default {
  beforeCreate() {
    const createEmitter = eventName => event => this.$emit(eventName, event)
    // this.onClick = createEmitter('click')
    this.onOpened = createEmitter('opened')
    this.onClosed = createEmitter('closed')
  }
}
